import { AircraftSource } from "@nova/constants"
import { OverviewState } from "./slice"

export const DottedAircraftIcon = ({
    type,
    source,
    className,
}: {
    type: keyof OverviewState["aircraft"]["types"]
    source: AircraftSource
    className?: string
}) => {
    const src = (() => {
        const base = "/images/dotted-aircraft-icons"
        if (source === "spidertracks") {
            return `${base}/fleet-manager.webp`
        }
        switch (type) {
            case "fixedWing":
                return `${base}/fixed-wing.webp`
            case "rotorcraft":
                return `${base}/rotorcraft.webp`
            case "lta":
                return `${base}/lta.webp`
            case "glider":
                return `${base}/glider.webp`
            case "other":
                return `${base}/unknown.webp`
            default:
                const _exhaustiveCheck: never = type
                return _exhaustiveCheck
        }
    })()
    return <img src={src} alt="" className={className} />
}
